<template>
  <v-switch
    :id="inputId"
    :label="metadados.infoTooltipText ? null : inputLabel"
    :disabled="campoDesabilitado"
    v-model="valorInterno"
    color="primary"
  >
    <template v-if="metadados.infoTooltipText" slot="label">
      <span class="MetadadosCampoDinamicoBoolean__label">
        <span>{{ inputLabel }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="ml-1 MetadadosCampoDinamicoBoolean__icon" v-on="on">info</v-icon>
          </template>
          <span>{{ metadados.infoTooltipText }}</span>
        </v-tooltip>
      </span>
    </template>
  </v-switch>
</template>
<script>
import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoBoolean',
  props: {
    value: {
      type: [Boolean],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
    valorInterno(novoValor) {
      if (novoValor === this.value) {
        return;
      }
      this.emiteValorAlterado(novoValor);
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredNome: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.objetoContainer[this.metadados.labelCampo];
          return !!(val) || msg;
        },
      },
    };
  },
  mounted() {
    const { valorDefault } = this.metadados;
    if (valorDefault) {
      this.valorInterno = valorDefault;
      this.emiteValorAlterado(this.valorInterno);
    }
  },
};
</script>
<style>
  .MetadadosCampoDinamicoBoolean__label {
    display: inline-flex;
    align-items: center;
  }
  .MetadadosCampoDinamicoBoolean__icon {
    font-size: 20px;
  }
</style>
